/*
 *
 * Package: `@dbh/hotel-main-services-theme`.
 *
 */const THEME_KEY_HOTEL_MAIN_SERVICES="hotelMainServices";const modifyHotelMainServicesTheme=a=>{let{spacing:{sp9:b}}=a;return {[THEME_KEY_HOTEL_MAIN_SERVICES]:{columns:2,visibleRowsWhenCollapsed:3,itemHeight:b}}};

export { THEME_KEY_HOTEL_MAIN_SERVICES, modifyHotelMainServicesTheme as default };
